module.exports = __webpack_public_path__ + "img/dagajoga-logo.10983b60.png";